module.exports = __webpack_public_path__ + "img/outlander6.bdeda42d.jpeg";